var publicData = require('./services/publicData');

var authorization = require('./services/authorization');
var router = require('./services/router');
var helpers = require('./services/helpers');
var keyboardActions = require('./services/keyboardActions');

var preloader = require('./components/preloader');

var Lines = require('./CreateNewOrder/Lines');
var messages = require('./components/messages');

var quotes = require('./ExistingOrders/quotes');

var CreateNewOrder = function () {
    var self = this;

    this.bulk_order_id = ko.observable('');

    this.isbns = ko.observable('');
    this.lines = new Lines();
    this.po_number = ko.observable('');
    this.notes = ko.observable('');

    this.is_exist_order = ko.computed(function () {
        return Boolean(self.bulk_order_id());
    });

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.is_existing_order = ko.computed(function () {
        return Boolean(self.bulk_order_id());
    });

    this.getData = function () {
        return {
            po_number: self.po_number().trim(),
            lines: self.lines.getData(),
            notes: self.notes()
        };
    };

    this.isValid = function () {
        var messages_list = [];
        var target_focus;

        self.po_number(self.po_number().trim());
        self.notes(self.notes().trim());

        self.po_number(self.po_number().trim());

        if (!self.lines.isValid()) {
            target_focus = 'isbns';
            messages_list.push('Please, add books in order with non-zero quantity');
        }

        if (!self.po_number()) {
            target_focus = 'po_number';
            messages_list.push('Please, fill "PO number" field');
        } else if (self.po_number().length > 11) {
            target_focus = 'po_number';
            messages_list.push('Max length of PO number is 11 symbols');
        } else if (!helpers.validatePONumber(self.po_number())) {
            messages_list.push('PO number must contain only alphanumeric characters');
        }

        if (messages_list.length == 0) return true;

        messages.addItems(messages_list.reverse(), {clear: true});
        helpers.focusSequence(messages_list.join( ), function () {
            self.focused(target_focus);
        });

        return false;
    };

    this.getISBNsForSearch = function() {
        return self.isbns().split(',').map(function (isbn) {
            return isbn.trim();
        })
    };

    this.isValidISBNs = function () {
        var isbns = self.getISBNsForSearch();

        var result = isbns.every(function (isbn_str) {
            var isbn = Number(isbn_str);
            var length = isbn_str.length;

            return length == 10 || (length == 13 && (isbn % 1 == 0))
        });

        if (result) return true;

        var message = 'ISBN length must contain only 10 or 13 digits';

        messages.addItem(message);
        helpers.focusSequence(message, function () {
            self.focused('isbns');
        });

        return false;
    };

    this.addByISBN = function () {
        function searchCallback(status, results) {
            if (!status) return;

            self.isbns('');

            self.lines.addItems(results.successful);

            if (results.failed.length == 0 ) return;

            results.failed.forEach(function (item) {
                if (!item.action) {
                    messages.addItem(item.message);
                    return;
                }

                if (item.action === 'force') {
                    messages.addItem(item.message, item.action, item.action_link, function () {
                        self.lines.addItem({
                            isbn: item.isbn,
                            title: '',
                            forced: true,
                            focused: true
                        });
                    });
                    return;
                }
                if (item.action === 'new_edition') {
                    messages.addItem(item.message, item.action, item.action_link, function () {
                        self.lines.addItem({
                            isbn: item.new_isbn,
                            title: item.title,
                            focused: true
                        });
                    });
                    return;
                }
            });
        }

        messages.removeAllItems();
        messages.setFocus();

        if(!self.isValidISBNs()) {
            messages.addItem('ISBN length must contain only 10 or 13 digits');
            return;
        }

        var isbns = self.getISBNsForSearch();
        var existing_isbns = self.lines.getItemsISBNS();
        for (var counter = 0; counter < isbns.length; ) {
            if (!existing_isbns[isbns[counter]]) {
                counter++;
                continue;
            }

            messages.addItem('ISBN ' + isbns[counter] +' already added. Quantity can be changed, if needed.');
            isbns.splice(counter, 1);
        }

        self.isbns(isbns.join(', '));

        if (isbns.length == 0) return;

        self.api.search(searchCallback);
    };

    this.fill = function (data) {
        self.isbns(data.isbns || '');
        self.lines.addItems(data.lines);
        self.po_number(data.po_number || '');
        self.notes(data.notes || '');
    };

    this.clean = function () {
        self.bulk_order_id('');

        self.isbns('');
        self.lines.clean();
        self.po_number('');
        self.notes('');
    };

    this.createOrder = function () {
        function createCallback(status) {
            if (!status) return;

            self.clean();
            messages.removeAllItems();

            quotes.refresh();
            router.goTo('default');
        }

        messages.removeAllItems();

        if (!self.isValid()) return;

        self.api.create(createCallback);
    };

    this.discardOrderChanges = function () {
        if (self.is_existing_order()) {
            router.goTo('default');
        }

        self.clean();
    };

    this.updateOrder = function () {
        function updateCallback(status) {
            if (!status) return;

            self.clean();

            quotes.refresh();
            router.goTo('default');
        }

        messages.removeAllItems();

        if (!self.isValid()) return;

        self.api.update(updateCallback);
    };

    this.onShow = function () {
        self.focused('title');
        if (!self.bulk_order_id()) return;

        self.api.get(function (status, data) {
            if (!status) return;

            self.fill(data);
        });
    };
    this.onHide = function () {
        self.focused('');
        self.clean();
    };

    this.api = {
        search: function (callback) {
            preloader.show('search-books');
            $.ajax({
                url: 'rest.php/get_books_by_isbn',
                method: 'POST',
                data: {
                    isbns: self.getISBNsForSearch()
                },
                dataType: 'json'
            }).done(function (resp) {
                callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false, error.message);
            }).always(function () {
                preloader.hide('search-books');
            });
        },
        get: function (callback) {
            preloader.show('get-quote');
            $.ajax({
                url: 'rest.php/quote/' + self.bulk_order_id(),
                method: 'GET',
                dataType: 'json'
            }).done(function (resp) {
                callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('get-quote');
            });
        },
        create: function (callback) {
            preloader.show('create-quote');
            $.ajax({
                url: 'rest.php/quote',
                method: 'POST',
                data: self.getData(),
                dataType: 'json'
            }).done(function (resp) {
                callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('create-quote');
            });
        },
        update: function (callback) {
            preloader.show('update-quote');
            $.ajax({
                url: 'rest.php/quote/' + self.bulk_order_id(),
                method: 'POST',
                data: self.getData(),
                dataType: 'json'
            }).done(function (resp) {
                callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('update-quote');
            });
        }
    };

    this.notesKeyDown = function (me, e) {
        if (!keyboardActions.isTab(e.keyCode)) return true;

        e.preventDefault();
        self.focused('discard-changes');
    }
};

module.exports = CreateNewOrder;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/CreateNewOrderPage.js
// module id = 18
// module chunks = 0